module.exports = "<div class=\"wrapper\">\n  <div class=\"sidebar\" data-color=\"black\" data-image=\"\">\n      <app-sidebar></app-sidebar>\n      <div class=\"sidebar-background\" style=\"background-image: url(/assets/img/sidebar.jpg)\"></div>\n  </div>\n\n  <div class=\"main-panel\">\n      <app-navbar></app-navbar>\n      <router-outlet></router-outlet>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /builds/iws/vanenet/src/app/main/layout/layout.component.html
// module id = ../../../../../src/app/main/layout/layout.component.html
// module chunks = main.module